import { companyApi } from "./api";
import type { User } from "../types/api";

export function roleHomePath(role: User["role"], companyType?: string): string {
  switch (role) {
    case "admin":
      return "/admin";
    case "company_user":
      return companyType === "consultancy" ? "/consultancy" : "/hr";
    case "affiliate":
      return "/affiliate";
    default:
      return "/";
  }
}

export async function resolveHomePath(user: User): Promise<string> {
  if (user.role !== "company_user") {
    return roleHomePath(user.role);
  }
  try {
    const membership = await companyApi.myCompany();
    return roleHomePath(user.role, membership.company_type);
  } catch {
    return "/hr";
  }
}
